import script from "./ListaAbertos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaAbertos.vue?vue&type=script&setup=true&lang=js"

import "./ListaAbertos.vue?vue&type=style&index=0&id=1482d5f9&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontendRegua\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1482d5f9"]])

export default __exports__